import { ActivityLogsList } from "#batteries-included-components/Layouts/ActivityLogs/ActivityLogsList";
import { AssetType } from "@validereinc/domain";
import React from "react";
import { FlowUpdateStatusBanner } from "./FlowUpdateStatusBanner";

export const ChangeLogTab = ({ resourceId }: { resourceId: string }) => {
  return (
    <>
      <FlowUpdateStatusBanner />
      <ActivityLogsList
        resourceId={resourceId}
        resourceType={{ name: AssetType.FLOW }}
      />
    </>
  );
};
